export default "__VITE_ASSET__76d27962__"